import type { CustomAttributeV2Fragment } from '~~/lib/Shop/generated/schema';

export type CustomAttributeV2_AttributeSelectedOptions_Fragment = {
  __typename: 'AttributeSelectedOptions';
  code: string;
  attribute_type: string | null;
  label: string;
  selected_options: Array<{
    __typename?: 'AttributeSelectedOption';
    label: string;
    value: string;
    uid: string;
  } | null>;
};

export function isAttributeSelectedOptions(
  p: CustomAttributeV2Fragment | undefined
): p is CustomAttributeV2_AttributeSelectedOptions_Fragment {
  return Boolean(
    p &&
    typeof p === 'object' &&
    'selected_options' in p &&
    Array.isArray((p as { selected_options?: unknown }).selected_options)
  );
}
